import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import axios from 'src/api/Api';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_SHIP_TO_ADDRESS_SUCCESS,
    GET_SHIP_TO_SEARCH_SUCCESS,
    GET_SHIP_TO_ADDRESS_FAILURE,
} from '../actions';
import {
    accountNumberZeroTrimmer,
    convertObjectToQueryParams,
} from 'src/utils/util';

export default function* getShipToAddress(action) {
    const value = action.payload.searchValue;

    // If accountId is explicitly passed in the payload (e.g. template flow), use it directly
    const payloadAccountId = action.payload?.accountId;

    const surgeryAccountId = yield select(
        (state) => state.surgeryReducer.surgeryDetails.accountId?.accountId
    );
    const selectedAccountDetails = yield select(
        (state) => state.replenishAccount
    );

    const billToShipToPartnerRole = yield select((state) => state.loginReducer.billToShipToPartnerRole);
    const sapPartnerId1 =
        selectedAccountDetails?.selectedAccount?.accountId ||
        surgeryAccountId;

    // sapPartnerId1 updated from sapPartnerId to add configuration for Japan User
    // countrycode, sapPartnerIdJapanUser and sapPartnerIdResult are created to change shippin method as ber BillToId

    const sapPartnerIdJapanUser = yield select(
        (state) => state.surgeryReducer.surgeryDetails.billToId?.billToNumber
    );
    const sapPartnerIdResult = function () {
        if (billToShipToPartnerRole == 'BILL_TO') {
            return sapPartnerIdJapanUser;
        } else return sapPartnerId1;
    };
    // Payload accountId takes priority when provided (template flow),
    // otherwise fall back to surgery/replenishment flow
    const sapPartnerId = payloadAccountId || sapPartnerIdResult();

    try {
        if (sapPartnerId) {
            const shipToParam = {
                sapPartnerId: sapPartnerId,
                searchTerm: value ? value : '',
            };
            const param = convertObjectToQueryParams(shipToParam);
            let result = yield axios
                .get(
                    `occ/v2/${localStorage.getItem(
                        'baseSiteId'
                    )}/order/surgery/shiptoaddress?${param}`
                )
                .then((response) => response.data);
            const newResult = {
                ...result,
                shipToData: {
                    ...result.shipToData,
                    nonTissueAddress: (
                        result.shipToData?.nonTissueAddress || []
                    )?.map((item) => {
                        const shippingAddress = `${
                            item.accountName
                        } ${accountNumberZeroTrimmer(item.shippingAddressId)}`;
                        item.formattedShippingAddressId = shippingAddress;
                        return item;
                    }),
                    tissueAddress: (
                        result.shipToData?.tissueAddress || []
                    )?.map((item) => {
                        const shippingAddress = `${
                            item.accountName
                        } ${accountNumberZeroTrimmer(item.shippingAddressId)}`;
                        item.formattedShippingAddressId = shippingAddress;
                        return item;
                    }),
                },
            };
            if (action.payload.searchValue) {
                yield put({
                    type: GET_SHIP_TO_SEARCH_SUCCESS,
                    payload: newResult?.shipToData || [],
                    statusCode: newResult?.statusCode,
                    statusMessage: newResult?.statusMessage,
                    loading: false,
                });
            } else if (!action.payload.searchValue) {
                yield put({
                    type: GET_SHIP_TO_ADDRESS_SUCCESS,
                    payload: newResult?.shipToData || [],
                    statusCode: newResult?.statusCode,
                    statusMessage: newResult?.statusMessage,
                    loading: false,
                });
                yield put({
                    type: GET_SHIP_TO_SEARCH_SUCCESS,
                    payload: newResult?.shipToData || [],
                    statusCode: newResult?.statusCode,
                    statusMessage: newResult?.statusMessage,
                    loading: false,
                });
            }
        }
    } catch (e) {
        yield logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/order/surgery/shiptoaddress`,
            requestPayload: action?.payload || '',
        });
        yield put({
            type: GET_SHIP_TO_ADDRESS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
